/* eslint-disable no-console */
import {OPKey} from '../pages/configurator/orgFacility/orgInfo/constants/orgProfileKeyLabel';
import useCompanyStore from '../store/companyStore/companyDetailsStore';

export const sortBy: (
  data: any[],
  key: string,
  type?: 'asc' | 'dec'
) => any[] = (data, key, type = 'dec') => {
  const sortedData = data?.sort((a, b) => {
    const aVal = a?.[key];
    const bVal = b?.[key];

    if (aVal === bVal) return 0;

    const modifier = type === 'asc' ? 1 : -1;

    if (typeof aVal === 'string' && typeof bVal === 'string') {
      return aVal.localeCompare(bVal) * modifier;
    }

    if (typeof aVal === 'number' && typeof bVal === 'number') {
      return (aVal - bVal) * modifier;
    }

    return String(aVal).localeCompare(String(bVal)) * modifier;
  });

  return sortedData;
};

export const excelSwitch = (obj: any): string => {
  const subCategory =
    useCompanyStore?.getState().companyDetails?.[OPKey.SUB_CATEGORY];
  const def = obj?.default ?? '';

  switch (subCategory) {
    case 6:
      return obj?.hotel_and_lodge ?? def;
    case 7:
      return obj?.footwear ?? def;
    case 8:
      return obj?.restaurant ?? def;
    default:
      return def;
  }
};

export const getUniqueArray = (array: any[], key: string): any[] => {
  const uniqueSet = new Set();
  if (array.length > 0) {
    return array?.filter((item) => {
      const isDuplicate = uniqueSet.has(item[key]);
      uniqueSet.add(item[key]); // Add the name to the set if not already added

      return !isDuplicate; // Only return unique items
    });
  } else {
    return [];
  }
};
